import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { installDemoNetworkGuard, isDemoRuntimePath } from './lib/demoNetworkGuard';

const root = ReactDOM.createRoot(document.getElementById('root'));
const googleClientId = String(process.env.REACT_APP_GOOGLE_CLIENT_ID || '').trim()
const currentPath = window.location?.pathname || ''
const isStaticDemoPath = isDemoRuntimePath(currentPath)

// This wrapper is path-aware, so direct loads and client-side navigation into
// `/demo` are both protected before any application component can run.
installDemoNetworkGuard()

// 전역 런타임 오류 수집(중앙로그가 없을 때 서버 로그로 모음)
let _clientLogHandlersInstalled = false
function installClientLogHandlers(reportClientLog) {
  if (_clientLogHandlersInstalled) return
  _clientLogHandlersInstalled = true

  try {
    window.addEventListener('error', (e) => {
      try {
        const route = window.location?.pathname || ''
        const url = window.location?.href || ''
        const ua = navigator?.userAgent || ''
        const msg = e?.message || (e?.error?.message) || 'window.error'
        const stack = e?.error?.stack || ''
        reportClientLog({ level: 'error', source: 'window.error', route, url, message: msg, stack, userAgent: ua })
      } catch (_) { }
    })

    window.addEventListener('unhandledrejection', (e) => {
      try {
        const route = window.location?.pathname || ''
        const url = window.location?.href || ''
        const ua = navigator?.userAgent || ''
        const reason = e?.reason
        const msg = (reason && reason.message) ? reason.message : String(reason || 'unhandledrejection')
        const stack = reason && reason.stack ? reason.stack : ''
        reportClientLog({ level: 'error', source: 'unhandledrejection', route, url, message: msg, stack, userAgent: ua })
      } catch (_) { }
    })
  } catch (_) { }
}

async function startRuntime() {
  if (isStaticDemoPath) {
    // A direct demo visit loads only the static demo bundle. Auth, React Query,
    // analytics, Google OAuth and axios/API modules are not imported at all.
    const { default: DemoApp } = await import('./DemoApp')
    root.render(
      <React.StrictMode>
        <DemoApp />
      </React.StrictMode>,
    )
    return
  }

  const [{ default: App }, { cacheRolesMeta, reportClientLog }, oauthModule] = await Promise.all([
    import('./App'),
    import('./lib/api'),
    googleClientId ? import('@react-oauth/google') : Promise.resolve(null),
  ])
  const GoogleOAuthProvider = oauthModule?.GoogleOAuthProvider
  const content = googleClientId && GoogleOAuthProvider
    ? <GoogleOAuthProvider clientId={googleClientId}><App /></GoogleOAuthProvider>
    : <App />

  root.render(<React.StrictMode>{content}</React.StrictMode>)
  cacheRolesMeta()
  installClientLogHandlers(reportClientLog)
}

startRuntime().catch((error) => {
  // No server-side logger is used here: a failed bootstrap must not create a
  // hidden network request, especially while the static demo is active.
  console.error('Failed to start the application.', error)
})

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();